import { createContext, useContext } from 'react'
import { ViewState } from 'react-map-gl'

export const US_VIEWPORT = {
  zoom: 4,
  latitude: 40.12941536221467,
  longitude: -95.890216,
  padding: {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20,
  },
  bearing: 0,
  pitch: 0,
}

export type MapGLViewport = ViewState

export type ViewportContextValue = {
  viewport: ViewState
  setViewport: (viewport: ViewState) => void
}

export const ViewportContext = createContext<ViewportContextValue>({
  viewport: US_VIEWPORT,
  setViewport: () => console.log('setViewport unset'),
})
ViewportContext.displayName = 'ViewportContext'

export const useViewportContext = () => useContext(ViewportContext)
